import React, { useState, useEffect } from 'react';
import Navbar from '../../navbar';
import Header from '../../header';
import FormHeader from '../../forms/formHeader/formHeader'
import { useDispatch, useSelector } from 'react-redux';
import { createFormMandatoryField, getFormMandatoryFields } from '../../../store/reducers/formMandatoryFieldsSlice'; // Adjust path as needed
import { getFormPageIds, hideAllPagesExceptCurrentFormPage, setInputFieldAndFormPageIds, loadForm } from '../../../utility/utility';
import FormLoader from '../../forms/formLoader';
import { useParams } from 'react-router-dom';

const AppFormCreation = () => {

  const [formIds, setFormIds] = useState([]);
  const [mandatoryFields, setMandatoryFields] = useState([])
  const [pageIds, setPageIds] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const user = useSelector((state) => state.auth.user);
  const { category, applicationName, formId } = useSelector((state) => state.counter.createFormData);
  const dispatch = useDispatch();
  const [isLoaded, setIsLoaded] = useState(false);
  const params = useParams();
  useEffect(() => {
    const fetchApplicationMandatoryFields = async () => {
      if (params.id && user.access_token) {
        const authToken = user.access_token;
        const data = await getFormMandatoryFields(params.id, authToken);
        if (data && data.length > 0 && data[0].mandatory_fields) {
          console.log("Mandatory fields found:", data[0].mandatory_fields);
          setMandatoryFields(data[0].mandatory_fields);
        } else {
          console.log("No mandatory fields configured for this form");
          setMandatoryFields([]); // Set empty array if no mandatory fields
        }
      }
    };
    fetchApplicationMandatoryFields();
  }, [user.access_token, params.id])
  // Use useEffect to dynamically add event listeners
  useEffect(() => {
    attachEventHandlers();
    console.log(category);
    // Cleanup event listeners on unmount
    return () => {
      formIds.forEach((id) => {
        const inputField = document.getElementById(id);
        if (inputField) {
          inputField.removeEventListener('click', handleInputChange);
        }
      });
    };
  }, [formIds, isLoaded]);

  useEffect(() => {
    // console.log(pageIds);
    hideAllPagesExceptCurrentFormPage(pageIds, currentPage);

  }, [pageIds])

  useEffect(() => {
    if (isLoaded) {
      const allInputs = document.querySelectorAll('input, textarea'); // adjust as needed
      allInputs.forEach((el) => {
        if (mandatoryFields.includes(el.id)) {
          el.style.backgroundColor = '#ff0000';
        }
        // else {
        //   el.style.backgroundColor = '';
        // }
      });
    }

  }, [isLoaded, mandatoryFields]);

  const handleInputChange = (event) => {
    const fieldId = event.target.id;

    setMandatoryFields((prevFields) => {
      if (prevFields.includes(fieldId)) {
        // Remove field from mandatoryFields
        event.target.style.backgroundColor = '';
        return prevFields.filter((id) => id !== fieldId);
      } else {
        // Add field to mandatoryFields
        // event.target.style.backgroundColor = '#ff0000'; // red
        return [...prevFields, fieldId];
      }
    });
  };

  // Function to attach event handlers
  const attachEventHandlers = () => {
    formIds.forEach((id) => {
      const inputField = document.getElementById(id);
      if (inputField) {
        // console.log("Event Listner Attached ",id);
        inputField.addEventListener('click', handleInputChange);
      }
    });
  };

  const handleCreate = () => {
    const newField = {
      form_id: formId,
      mandatory_fields: mandatoryFields,
    };
    const authToken = user.access_token;
    dispatch(createFormMandatoryField({ data: newField, authToken }));
  };


  return (
    <div>
      <Navbar />
      <Header />
      <div className='wrapper'>

        <div className='profHeader'>
          <div className='profHeadLeft'>
            <h2>{category}</h2>
            <span>Select mandatory fields*</span>
          </div>

          <div >
            <a href='#' className='buttonPrimary' onClick={handleCreate}>Save</a>
          </div>
        </div>
        <div className='sp20'></div>
        <FormHeader applicationName={applicationName} currentPage={currentPage} totalPages={pageIds.length} pageIds={pageIds} setCurrentPage={setCurrentPage} />
        <FormLoader applicationName={applicationName} setFormIds={setFormIds} setPageIds={setPageIds} setIsLoaded={setIsLoaded} />

      </div>

    </div>
  )
}
export default AppFormCreation